import React, { useState, useEffect } from "react";
import "./SteperBooking.css";
import { MdEditLocationAlt } from "react-icons/md";
import { AiFillCar } from "react-icons/ai";
import { BiChevronsRight } from "react-icons/bi";
import { FaUserFriends } from "react-icons/fa";
import { BsBagFill } from "react-icons/bs";
import { MdAccessTimeFilled } from "react-icons/md";
import { TbBottle } from "react-icons/tb";
import { FaPrescriptionBottleAlt } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";
import { MdFamilyRestroom } from "react-icons/md";
import { BsPersonFill } from "react-icons/bs";
import { TbArrowsLeftRight } from "react-icons/tb";
import car1 from "./../../../src/assets/images/car1.jpg";
import { MdPayment } from "react-icons/md";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { IoIosPeople } from "react-icons/io";
import { RiLuggageCartFill } from "react-icons/ri";
import { setTotalValue } from "../../redux/CustomerReducer";
import { TbLuggage } from "react-icons/tb";
import { BsCurrencyPound } from "react-icons/bs";
import { TiTick } from "react-icons/ti";
import logo from "./../../assets/images/logo.png";
import carImage from "./../../assets/images/car.png";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { bookeVehicle } from "../../redux/CustomerReducer";
import { IoMdBus } from "react-icons/io";
import { BiLoaderAlt } from "react-icons/bi";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { setObjBookingDet } from "../../redux/CustomerReducer";
import BookingAddressDetail from "../BookingAddressDetail/BookingAddressDetail";
const SteperBooking = () => {
  const cookies = new Cookies();

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const vehiclesData = useSelector(
    (state) => state?.AdminReducer?.allVehiclesData
  );
  // const userId = useSelector(
  //   (state) => state?.CustomerReducer?.currentCustomer?.user?._id
  // );
  // const userId=cookies.get("_id")

  const userId = cookies.get("_id");

  console.log("vehiclesData", vehiclesData);

  let idOfUser = "";

  if (userId) {
    idOfUser = userId;
  }

  const dispatch = useDispatch();
  const location = useLocation();
  console.log("locationState totalDistance", location?.state?.totalDistance);
  console.log("locationStatemm image", location?.state?.image);
  console.log("locationState", location?.state?.departureLocation);
  console.log("locationState", location?.state?.via1);
  console.log("locationState", location?.state?.via2);
  console.log("locationState", location?.state?.via3);
  console.log("locationState", location?.state?.arrivalLocation);
  console.log("locationState", location?.state?.passenger);
  console.log("locationState departureDate", location?.state?.departureDate);
  console.log("locationState departureTime", location?.state?.departureTime);
  console.log("locationState returnDate", location?.state?.returnDate);
  console.log("locationState", location?.state?.arrivalTime);
  console.log("locationState makeDisable", location?.state?.makeDisable);

  console.log("hourly111 location", location?.state?.departureLocation);
  console.log("hourly111 hourlyDuration", location?.state?.hourlyDuration);
  console.log("hourly111 hourlyTime", location?.state?.hourlyTime);
  console.log("hourly111 startDateHourly", location?.state?.startDateHourly);

  const bookNowClicked = async (item) => {
    dispatch(setTotalValue(location?.state?.totalPrice));

    const data = {
      passenger: location?.state?.passenger,
      bookingAmount: location?.state?.totalPrice,
      pickUpLocation: location?.state?.departureLocation,
      arrivalLocation: location?.state?.arrivalLocation,
      pickUpDate: location?.state?.departureDate,
      pickUpTime: location?.state?.departureTime,
      returnPickUpTime: location?.state?.arrivalTime,
      returnPickUpDate: location?.state?.departureDate,
      userId: idOfUser,
    };

    const tempDataBooking = {
      passenger: location?.state?.passenger,
      bookingAmount: location?.state?.totalPrice,
      pickUpLocation: location?.state?.departureLocation,
      arrivalLocation: location?.state?.arrivalLocation,
      pickUpDate: location?.state?.departureDate,
      pickUpTime: location?.state?.departureTime,
      returnPickUpTime: location?.state?.arrivalTime,
      returnPickUpDate: location?.state?.departureDate,
      makeDisable: location?.state?.makeDisable,
      catagory: item.catagory,
      company: item.company,
      finalLugagge: location?.state?.finalLugagge,
      img: item.image,
  
    };

    dispatch(setObjBookingDet(tempDataBooking));
    const response = await dispatch(bookeVehicle(data));

    console.log("response", response?.payload?.data?.message);
    Swal.fire(response?.payload?.data?.message, "success");
    if (response?.payload?.data?.message) {
      if (idOfUser) {
        navigate("/payment", {
          state: {
            passenger: location?.state?.passenger,
            bookingAmount: location?.state?.totalPrice,
            pickUpLocation: location?.state?.departureLocation,
            arrivalLocation: location?.state?.arrivalLocation,
            pickUpDate: location?.state?.departureDate,
            pickUpTime: location?.state?.departureTime,
            returnPickUpTime: location?.state?.arrivalTime,
            returnPickUpDate: location?.state?.departureDate,
            returnPickUpDate: location?.state?.departureDate,
          },
        });
        // navigate("/payment")
      } else {
        navigate("/register-booking");
      }
    }
  };

  console.log("location?.state?.tab", location?.state?.tab);
  useEffect(() => {
    // simulate an async action
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []); // pass an empty array to only run this effect once

  const SelectClicked=(item)=>{
let newPrice;
    if(location?.state?.totalDistance)
    {
      newPrice= (location?.state?.totalDistance * 0.621371192).toFixed(2)*item.price
    }
if(location?.state?.hourlyDuration)
{
  newPrice=  Number(location?.state?.hourlyDuration)*item.price

}
 

    navigate("/payment", {
      state: {
        makeDisable: location?.state?.makeDisable,
        departureLocation: location?.state?.departureLocation,
        arrivalLocation: location?.state?.arrivalLocation,
        totalDistance: location?.state?.totalDistance,
        departureDate: location?.state?.departureDate,
        departureTime: location?.state?.departureTime,
        tab: location?.state?.tab,
        hourlyDuration:location?.state?.hourlyDuration,
        startDateHourly: location?.state?.startDateHourly,
        via1: location?.state?.via1,
        via2: location?.state?.via2,
        via3: location?.state?.via3,
        price: newPrice,
        image:item?.image,
        catagory: item.catagory,
      },
    });
    

  }

  console.log("calculatePriceClicked",location?.state)
  return (
    <>
      <div>
        {isLoading ? (
          <div className="mainContainerLoader">
            <img src={logo} className="logoAlertImg" />

            {/* <div className="alertTxt">Please wait .....</div> */}

            <div className="topLoaderIconsAlert">
              <IoMdBus className="busIcon" />
              <BiLoaderAlt className="loaderIconAlert" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className="mainStepper">
        <div className="topStepperSingle">
          <div className="topIconDesc">
            <div className="stepperCircle">
              <MdEditLocationAlt className="iconStepper" />
            </div>
            <div className="steppeBtmTxt">Journey</div>
          </div>
          <div className="stepperLine"></div>
        </div>
        <div className="topStepperSingle">
          <div className="topIconDesc">
            <div className="stepperCircle">
              <AiFillCar className="iconStepper" />
            </div>
            <div className="steppeBtmTxt">Vehicle</div>
          </div>
          <div className="stepperLine stepperLineColorless"></div>
        </div>
        {/* <div className="topStepperSingle">
          <div className="topIconDesc">
            <div className="stepperCircle stepperCircleColorless">
              <BsPersonFill className="iconStepper" />
            </div>
            <div className="steppeBtmTxt">Registration</div>
          </div>
          <div className="stepperLine stepperLineColorless"></div>
        </div> */}
        <div className="topStepperSingle">
          <div className="topIconDesc">
            <div className="stepperCircle stepperCircleColorless">
              <MdPayment className="iconStepper" />
            </div>
            <div className="steppeBtmTxt">Payment</div>
          </div>
        </div>
      </div>

<BookingAddressDetail/>
      {/* {location?.state?.tab === 0 && location?.state?.makeDisable && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div>{location?.state?.departureLocation}</div>
            <BiChevronsRight className="iconsBooking" />
            <div className="durationTxtStprBkingArri">
              {location?.state?.arrivalLocation}
            </div>
            <div className="durationTxtStprBking">
              Duration: about 1 hour – Distance:{" "}
              {(location?.state?.totalDistance * 0.621371192).toFixed(2)} MI
            </div>
            <div className="durationTxtStprBking">
              Date:{moment(location?.state?.departureDate).format("YYYY-MM-DD")}
              , Time: {location?.state?.departureTime}
            </div>
          </div>
        </div>
      )}

      {location?.state?.tab === 0 && !location?.state?.makeDisable && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div>{location?.state?.departureLocation}</div>
            <TbArrowsLeftRight className="iconsBooking" />
            <div className="durationTxtStprBkingArri">
              {location?.state?.arrivalLocation}
            </div>
            <div className="durationTxtStprBking">
              Duration: about 1 hour – Distance:{" "}
              {location?.state?.totalDistance}Km
            </div>
            <div className="durationTxtStprBking">
              Date:{moment(location?.state?.departureDate).format("YYYY-MM-DD")}
              , Time: {location?.state?.departureTime}
            </div>
          </div>
        </div>
      )}

      {location?.state?.tab === 1 && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div className="durationTxtStprBkingArri">
              {location?.state?.departureLocation}
            </div>
            <div className="durationTxtStprBking">
              {" "}
              Time: {location?.state?.hourlyDuration}
            </div>
            <div className="durationTxtStprBking">
              Date:
              {moment(location?.state?.startDateHourly).format("YYYY-MM-DD")}
            </div>
          </div>
        </div>
      )} */}
      <div className="mainConatinerCardDetails">
        {vehiclesData?.map((item) => (
          <div className="mainConatinerCardDetailsInner">
            <div className="topHeadingStpBooking">{item.catagory}</div>
            <div className="cardTxtStpBooking">
             {item.company}
            </div>
            <div className="topMaxPeBag">
              <div className="topMaxPeBagInner">
                <FaUserFriends />
                <div>max. {item.passenger}</div>
              </div>
              <div className="topMaxPeBagInner">
                <BsBagFill />
                <div>max. {item.luggage}</div>
              </div>
            </div>

            <div className="lineBtwStpr"></div>
            <div className="topMiddleRowStpBooking">
              <div className="topMiddleStprBookingTop">
              { location?.state?.tab===0&& 
              <div className="topMiddleStprBooking">
                  <MdAccessTimeFilled />
                  <div className="txtMiddleStpBok">
                    Free 60 minutes wait time for airport pickups, 15 mins for
                    all others
                  </div>
                </div>}
                <div className="topMiddleStprBooking">
                  <MdFamilyRestroom />
                  <div className="txtMiddleStpBok">Includes Meet & Greet</div>
                </div>
                <div className="topMiddleStprBooking">
                  <RxCrossCircled />
                  <div className="txtMiddleStpBok">
                    Free cancellation up until 1 hour before pickup
                  </div>
                </div>
                <div className="topMiddleStprBooking">
                  <TbBottle />
                  <div className="txtMiddleStpBok">
                    Complimentary bottled water
                  </div>
                </div>
              </div>

              <img src={item.image} />

              <div className="priceCardStpBooking">
               { location?.state?.totalDistance&&<div className="totalPriceStpBooking"> {(((location?.state?.totalDistance * 0.621371192).toFixed(2))*item.price).toFixed(2)} USD</div>}
              { location?.state?.hourlyDuration&& <div className="totalPriceStpBooking"> {Number(location?.state?.hourlyDuration)*item.price} USD</div>}
                <div className="descPricesStpBooking">
                  All prices include VAT, fees & tip.
                </div>
                <div className="selectBtn"
                
                onClick={()=>SelectClicked(item)}
                > Select</div>
              </div>
            </div>
          </div>
        ))}

        {/* <div className="topMapVehicles">
          {vehiclesData?.map((item) => (
            <div className="mainContainerVehicle">
              <div className="topVehicleRow1">
                <p className="carNameTxt">{item.catagory}</p>
                <div className="topIconVehTxt">
                  <IoIosPeople />
                  <p>{item.passenger} Passengers</p>
                </div>
                <div className="topIconVehTxt">
                  <RiLuggageCartFill />
                  <p>{item.luggage} Luggage</p>
                </div>
                <div className="topIconVehTxt">
                  <TbLuggage />
                  <p>2 Hand Luggage</p>
                </div>
              </div>

              <div className="carDescTxt">{item.company}</div>

              <div className="topVehicleRow3">
                <div>
                  <img className="imgCarBookCrd" src={item.image} />
                </div>

                <div className="topSecondColumR3BookCrd">
                  <div className="topAmountBookCard">
                    <BsCurrencyPound className="oldPricIcon" />
                    <span className="oldPriceTxt">113.00 - </span>
                    <div className="crossLineOldPrice"></div>
                    <BsCurrencyPound />
                    {parseInt(Number(item.price) + location?.state?.totalPrice)}
                  </div>
                  <div className="topTickCanceFree">
                    <div className="backGroundTickIcon">
                      <TiTick />
                    </div>
                    <div className="freeCanceTxt">FREE Cancellation</div>
                  </div>
                  <div className="topTickCanceFree">
                    <TiTick className="tickIcon" />
                    <div className="noHiddentTxt">No Hidden Costs</div>
                  </div>
             
                  <div
                    className="bookNowButton"
                    onClick={() => bookNowClicked(item)}
                  >
                    Book Now
                  </div>
              
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </div>
    </>
  );
};

export default SteperBooking;
